module.exports = __webpack_public_path__ + "static/media/team_bond_desktop.5267cf2c.png";